module.exports = __webpack_public_path__ + "img/9dbd644.png";